import { createSelector } from '@reduxjs/toolkit';
import { UserAccessRight } from '../../../general/model';
import { CHNodeIsFolder } from '../../../general/node';
import { RootSelector } from '../../models/rootSelector';
import { getPage } from '../app/selectors';
import { getRelativeLocation } from '../breadcrumbs/selectors';
import { getSelectedNodesInCurrentFolder } from '../fileManager/selectors/selectors';
import { Page } from '../../models/page';

export const getEligibleNodes: RootSelector<ReturnType<typeof getSelectedNodesInCurrentFolder>> =
  createSelector([getSelectedNodesInCurrentFolder], (selectedNodes) => {
    return selectedNodes.filter(
      (node) => !CHNodeIsFolder(node) && node.perms.includes(UserAccessRight.write),
    );
  });

export const getVisible: RootSelector<boolean> = createSelector(
  [getPage, getRelativeLocation],
  (page, relativeLocation) => {
    return page !== Page.SEARCH && page !== Page.TRASH && relativeLocation.inCreative;
  },
);

export const getEnabled: RootSelector<boolean> = createSelector(
  [getVisible, getEligibleNodes],
  (visible, eligibleNodes) => visible && eligibleNodes.length > 0,
);
